import { Button } from "@mui/material";
import React from "react";

const BaseButton = ({ children, variant = "contained", fullWidth = true, sx = {}, ...props }) => (
  <Button
    variant={variant}
    fullWidth={fullWidth}
    sx={{
      textTransform: "none",
      fontWeight: 500,
      borderRadius: 2,
      py: 1.2,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Button>
);

export default BaseButton;
